import { motion } from "framer-motion";

const links = [
  { label: "About", href: "#about", testId: "nav-link-about" },
  { label: "Contact", href: "#contact", testId: "nav-link-contact" },
];

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 2.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-noir/70 border-b border-gold/10"
      data-testid="main-nav"
    >
      <div className="flex items-center justify-between px-6 md:px-12 lg:px-24 py-5">
        <a
          href="#top"
          data-testid="nav-brand"
          className="font-serif text-lg md:text-xl tracking-[0.45em] text-cream hover:text-gold transition-colors duration-500"
        >
          ZENIQUE
        </a>
        <nav className="flex items-center gap-6 md:gap-10">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testId}
              className="gold-underline-link text-[11px] md:text-xs tracking-[0.3em] uppercase text-taupe hover:text-cream transition-colors duration-500"
            >
              {link.label}
            </a>
          ))}
        </nav>
      </div>
    </motion.header>
  );
}
